import {
  HomeIcon,
  LockIcon,
  PersonIcon,
  SearchRecentIcon,
  SettingsIcon,
  TeamIcon,
} from '@shopify/polaris-icons';
import type {AccountUrls, NavSectionDef} from '@slj/ui/app-frame';

/** User-menu account links — same-origin on the identity app itself. One const so
 *  a route move can't strand one view signing users out to a 404. */
export const identityAccount: AccountUrls = {settingsUrl: '/settings', signOutUrl: '/sign-out'};

/**
 * Identity's left-nav definition. Lives view-side (never in route-handler
 * props): IconSource values are components and window.__PAGE__ is JSON, so
 * anything icon-bearing must be constructed identically on both sides of the
 * hydrate. Labels match the Page titles exactly.
 */
export function identitySections(isAdmin: boolean): NavSectionDef[] {
  const sections: NavSectionDef[] = [
    {
      items: [
        {label: 'Home', url: '/', icon: HomeIcon},
        {label: 'Settings', url: '/settings', icon: SettingsIcon},
        {label: 'Security', url: '/settings/security', icon: LockIcon},
      ],
    },
  ];
  if (isAdmin) {
    sections.push({
      title: 'Admin',
      items: [
        {label: 'People', url: '/admin', icon: PersonIcon},
        {label: 'Groups', url: '/admin/groups', icon: TeamIcon},
        {label: 'Audit', url: '/admin/audit', icon: SearchRecentIcon},
      ],
    });
  }
  return sections;
}
